<div class="w-100 mt-3">
  <!-- QUANDO TIVER INCONSISTENCIAS DE PRODUTOS -->
  @if (inconsistenciasProdutos) {
    <div class="row py-2">
      <!-- QUANDO TIVER ALGUMA INCONSISTENCIA (LENGTH > 0) -->
      <div class="col-12">
        <!-- DIVs LOADER PARA DEPARA PRODUTOS -->
        @if (enviandoIgnorarTodos) {
          <div class="loaderDepara float-end mt-0">
            <div class="text-center">
              <output class="spinner-border c-primary" aria-live="polite">
                <span class="visually-hidden">Enviando os dados ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Enviando os dados</p>
          </div>
        }
        @if (erroIgnorarTodos) {
          <div class="loaderDeparaErro float-end">
            <p class="legenda-erro-envio">Ocorreu um erro. Tente novamente.</p>
          </div>
        }
        @if (sucessoIgnorarTodos) {
          <div class="loaderDeparaSucesso float-end">
            <p>Sucesso, produtos ignorados!</p>
          </div>
        }
        <div>
          @if (qtdeInconsistencias>0) {
            <button class="botao-outline mb-4 mt-2"
              (click)="ignorarTodasInconsistencias()"
              [tag]="addTagManagerInteraction('box:button:click', 'prosseguir-sem-realizar-tratativas')"
            >PROSSEGUIR SEM REALIZAR TRATATIVAS</button>
          }
          @if (!qtdeInconsistencias) {
            <span class="botao-outline mb-4 mt-2 bg-light d-inline-block"
              title="Você já pode prosseguir para o resumo da importação"
              [tag]="addTagManagerInteraction('box:button:click', 'prosseguir')"
            >✓ PROSSEGUIR</span>
          }
        </div>
        @if (enviandoIgnorarTodos || erroIgnorarTodos || sucessoIgnorarTodos) {
          <div><br><br><br><br></div>
        }
        @for (inconsistencia of inconsistenciasProdutos; track inconsistencia; let i = $index) {
          <div class="row mb-2">
            <div class="col-12 mt-2">
              <div class="card-inconsistencia">
                <div class="row ps-3">
                  @if (inconsistencia.processado == 'N') {
                    <div class="coluna-seta"
                      (click)="abrirFecharResolucao(i + 1)"
                      (keydown.enter)="abrirFecharResolucao(i + 1)"
                      [tag]="addTagManagerInteraction('select:accordion:click', 'accordion')"
                      >
                      <i class="fa fa-chevron-right c-primary icone-abre-fecha"
                      id="flechaResolucao2{{i + 1}}" aria-hidden="true"></i>
                    </div>
                  }
                  @if (inconsistencia.processado == 'S') {
                    <div class="coluna-seta">
                      <i class="fa fa-check c-primary" aria-hidden="true"></i>
                    </div>
                  }
                  <div class="coluna-mensagem">
                    @if (inconsistencia.processado == 'N') {
                      <p class="info-inconsistencia">
                      Tipo de benefício não encontrado</p>
                    }
                    @if (inconsistencia.processado == 'S') {
                      <p class="info-inconsistencia">
                      Inconsistência resolvida ✓</p>
                    }
                  </div>
                  <div class="coluna-tarifa">
                    @if (inconsistencia.descricao) {
                      <p class="info-inconsistencia"
                        >
                      Benefício - {{inconsistencia.cdCodVenPro}} {{inconsistencia.descricao}}</p>
                    }
                  </div>
                  <div class="coluna-tarifa">
                    @if (inconsistencia.productValue) {
                      <p class="info-inconsistencia"
                        >Tarifa -
                        {{inconsistencia.productValue | currency:"BRL":"symbol"}}
                      </p>
                    }
                  </div>
                  <div class="coluna-status">
                    @if (inconsistencia.processado == 'N') {
                      <i
                        class="fa fa-exclamation-circle c-warning icone-status"
                        data-bs-toggle="tooltip" data-placement="top"
                        title="Inconsistência não resolvida" aria-hidden="true"
                      [tag]="addTagManagerInteraction('select:icon:click', 'informativo&inconsistencia-nao-resolvida')"></i>
                    }
                    @if (inconsistencia.processado == 'S') {
                      <i
                        class="fa fa-check-circle c-secondary icone-status"
                        data-bs-toggle="tooltip" data-placement="top"
                        title="Inconsistência resolvida." aria-hidden="true"
                      [tag]="addTagManagerInteraction('select:icon:click', 'informativo&inconsistencia-resolvida')"></i>
                    }
                  </div>
                  <!-- COLUNA QUE FICA ESCONDIDA E APARECE AO CLICAR NA SETA -->
                  <div class="coluna-resolucao d-none" id="colunaResolucao2{{i + 1}}">
                    <div class="row">
                      <!-- SELECIONAR REGIÃOOOOOOOOOOOOOOOOOOOOOOOO -->
                      <div class="col-12 col-lg-4">
                        <div class="my-3">
                          <h3 class="titulo-resolucao">REGIÃO</h3>
                          @if (regioesCadastradas) {
                            <app-select class="w-100"
                              [value]="inconsistencia.regiao"
                              (valueChanges)="inconsistencia.regiao = $event"
                              name="regioesCadastradas"
                              [options]="regioesCadastradas"
                              (change)="consultaFabricantes($event.target.value, inconsistencia.numeroLinha)"
                              (change)="consultaProduto($event.target.value, inconsistencia.numeroLinha)"
                              defaultDescription="Selecione"
                              optionValue="idRegiao"
                              optionText="descricaoRegiao"
                              [tag]="addTagManagerInteraction('select:dropdown:click', 'regiao')">
                            </app-select>
                          }
                        </div>
                      </div>
                      <!-- Loader REGIÕES -->
                      @if (regioesCadastradas == null) {
                        <div class="col-12 col-lg-4">
                          <div class="text-center my-3">
                            <output class="spinner-border c-primary" aria-live="polite">
                              <span class="visually-hidden">Consultando regiões
                              ...</span>
                            </output>
                          </div>
                          <p class="legenda-spinner">Consultando regiões ...</p>
                        </div>
                      }
                      <!-- Erro consulta de regiões -->
                      @if (regioesCadastradas === false) {
                        <div class="col-12 col-lg-4">
                          <p class="legenda-spinner c-danger">Ocorreu um erro na
                          consulta das regiões</p>
                        </div>
                      }
                      <!-- Loader fabricantes -->
                      @if (inconsistencia.regiao) {
                        <div class="col-12 col-lg-4"
                          [ngClass]="{'d-none' : !loaderProdutos}">
                          <div class="text-center my-3">
                            <output class="spinner-border c-primary" aria-live="polite">
                              <span class="visually-hidden">Consultando fabricantes
                              ...</span>
                            </output>
                          </div>
                          <p class="legenda-spinner">Consultando fabricantes ...</p>
                        </div>
                        <!-- SELECIONAR BENEFÍCIOOOOOOOOOO PRODUTOOOOOOOOOOOOOOO -->
                        <div class="col-12 col-lg-4"
                          [ngClass]="{'d-none' : loaderProdutos}">
                          <div class="my-3">
                            <h3 class="titulo-resolucao">BENEFÍCIO (produto)</h3>
                            <app-multiselect-custom class="w-100"
                              (changed)="exibeNomeBeneficio($safeNavigationMigration($event?.descricaoProduto), inconsistencia.numeroLinha)"
                              [model]="inconsistencia.nomeProduto"
                              [items]="inconsistencia.produtos"
                              bindLabel="descricaoProduto"
                              bindValue="descricaoProduto"
                              placeholder="Nome do produto"
                              [tag]="addTagManagerInteraction('select:dropdown:click', 'beneficio-produto')">
                            </app-multiselect-custom>
                          </div>
                        </div>
                      }
                      <!-- Loader produtos (benefício) -->
                      @if (inconsistencia.fabricante && !inconsistencia.produtos) {
                        <div class="col-12 col-lg-4"
                          >
                          <div class="text-center my-3">
                            <output class="spinner-border c-primary" aria-live="polite">
                              <span class="visually-hidden">Consultando produtos...</span>
                            </output>
                          </div>
                          <p class="legenda-spinner">Consultando produtos ...</p>
                        </div>
                      }
                    </div>
                    <!-- DIVs LOADER PARA DEPARA PRODUTOS -->
                    @if (enviandoParaApi === true) {
                      <div class="loaderDepara">
                        <div class="text-center">
                          <output class="spinner-border c-primary" aria-live="polite">
                            <span class="visually-hidden">Enviando os dados ...</span>
                          </output>
                        </div>
                        <p class="legenda-spinner">Enviando os dados</p>
                      </div>
                    }
                    @if (inconsistencia.processado == 'E') {
                      <div class="loaderDeparaErro">
                        <p class="legenda-erro-envio">Ocorreu um erro. Verifique se o
                        benefício escolhido é válido.</p>
                      </div>
                    }
                    @if (inconsistencia.processado == 'S') {
                      <div class="loaderDeparaSucesso">
                        <p>Sucesso, produto atualizado!</p>
                      </div>
                    }
                    <!-- FIM - DIVs LOADER PARA DEPARA DE PRODUTOS -->
                    <div class="my-4">
                      <h3 class="titulo-resolucao">NÃO PERGUNTAR NOVAMENTE</h3>
                      <!-- Sem economia ou COM ECONOMIA -->
                      <label class="label-customaziada"
                      for="switchPerguntaNovamente{{i+1}}">Não</label>
                      <div class="form-check form-switch ms-38">
                        <input [(ngModel)]="inconsistencia.gravaBanco"
                          type="checkbox" class="form-check-input"
                          id="switchPerguntaNovamente{{i+1}}"
                          [tag]="addTagManagerInteraction('select:toggle:click', 'nao-perguntar-novamente')"
                          >
                        <label class="form-check-label"
                        for="switchPerguntaNovamente{{i+1}}">Sim</label>
                      </div>
                    </div>
                    @if (inconsistencia.processado == 'N') {
                      <button class="botao-outline me-3"
                        (click)="ignorarInconsistenica(inconsistencia)"
                        [tag]="addTagManagerInteraction('box:button:click', 'ignorar-inconsistencia')"
                      >IGNORAR INCONSISTÊNCIA</button>
                    }
                    @if (inconsistencia.processado == 'S') {
                      <button class="botao-outline disabled me-3"
                      tabindex="0" disabled>IGNORAR INCONSISTÊNCIA</button>
                    }
                    @if (inconsistencia.processado == 'S') {
                      <button class="botao disabled"
                      tabindex="0" disabled>ALTERAR</button>
                    }
                    @if (inconsistencia.processado == 'N') {
                      <button class="botao"
                        (click)="deParaInconsistencia(inconsistencia)"
                        [tag]="addTagManagerInteraction('box:button:click', 'alterar')"
                      >ALTERAR</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }

  <!-- ENQUANTO NÃO TEM OS DADOS DAS INCONSISTENCIAS -->
  @if (inconsistenciasProdutos === null) {
    <div class="row">
      <div class="col-12 mt-3">
        <div class="text-center">
          <output class="spinner-border c-primary" aria-live="polite">
            <span class="visually-hidden">Consultando inconsistências de produto ...</span>
          </output>
        </div>
        <p class="legenda-spinner">Consultando inconsistências de produto ...</p>
      </div>
    </div>
  }
  <!-- Caso de erro na API -->
  @if (inconsistenciasProdutos === undefined) {
    <div class="row py-2">
      <!-- Caso de erro na API -->
      <div class="col-12 text-center">
        <h3 class="titulo-erro">Ocorreu um erro!</h3>
        <p class="descricao-sem-inconsistencias">Não foi possível consultar as inconsistências de produtos.
        </p>
      </div>
    </div>
  }
  <!-- CASO TENHA INCONSISTENCIAS DE PRODUTOS -->
  @if (inconsistenciasProdutos && !inconsistenciasProdutos.length) {
    <div class="row py-2">
      <!-- Caso não tenha inconsistencias -->
      <div class="col-12 text-center">
        <h3 class="titulo-sem-inconsistencias">Tudo certo! ✓</h3>
        <p class="descricao-sem-inconsistencias">Você não possui inconsistências relacionadas a produto
        (benefício).</p>
      </div>
    </div>
  }
</div>
